import { gql } from "@apollo/client";

const USER = gql`
  query user($id: ID!) {
    user(id: $id) {
      id
      name
      email
    }
  }
`;

export default USER;
